import { Grid } from '@radix-ui/themes';
import { IFormGrid } from 'interfaces/forms/grid';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const CommonFormGrid = (props: IFormGrid) => (
  <Grid
    columns={props.columns.toString()}
    gap={props.gap ?? RADIX.FLEX.GAP.FORM}
    align="start"
    className={props.className}
  >
    {props.children}
  </Grid>
);
